export default __webpack_public_path__ + "static/media/ray.b2de1f5a.svg";